import { Context } from 'Context/Context';
import { getCaseType } from 'Utils';
import React, { useContext } from 'react'
import DownloadDetailsOnProfContent from './DownloadDetailsOnProfContent';
import ProfessionalsInvolved from './ProfessionalsInvolved';
import useIsMobile from 'Hooks/useIsMobile';

function SubHeaderOnProfContent({attorney, isResponseReceived, caseDetails, onDownload, downloadButtonRef, hasAccess, isCaseOpen}) {
    const {userDetails} = useContext(Context);
    const isMobile = useIsMobile();
    const userInfo = attorney ? attorney.userId : userDetails;
  return (
    <div className='w-full   '>
      
    {isMobile ? 
    null
    : <div className='mb-2 text-[16px] '>Hello <span className=''>{userInfo?.firstName}  {userInfo?.lastName},</span></div>}
    <div className='text-[14px] '>
      {
      isMobile ?
      null 
      :
      (!isCaseOpen && caseDetails?.caseToProfStatus !== 5 ? 
      
      
      <div className='text-red-700'>
        Please note that this case is closed and you cannot make any further progress with this case.
        </div>
      :
      <>Below is your case status and the details provided by the client for the case <span className='text-green-600 font-bold'>{getCaseType(caseDetails?.caseType)}</span></>
      )
      }
      
          {hasAccess &&
         <div className=''>
         {caseDetails?.isCaseClosedByUser ?
             (caseDetails?.caseStatus ==="closed" ?
                 <DownloadDetailsOnProfContent
                 caseDetails={caseDetails} 
                 onDownload = {onDownload}
                 downloadButtonRef = {downloadButtonRef}
                 isResponseReceived={isResponseReceived}
                 />
               :
               "")
               :
                 <DownloadDetailsOnProfContent 
                 caseDetails={caseDetails} 
                 onDownload = {onDownload}
                 isResponseReceived={isResponseReceived}
                 downloadButtonRef = {downloadButtonRef}
                 />
             }
         </div>
          }
    
    </div>
</div>
  )
}

export default SubHeaderOnProfContent